// Libraries
import React from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import {ConfigProvider} from 'antd';
import esES from 'antd/locale/es_ES';
import ptPT from 'antd/locale/pt_PT';
import {store} from './store/store';
import './i18n';

// Styles 
import './styles/index.css';

// Components and Subcomponents
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <ConfigProvider locale={process.env.REACT_APP_LOCALE === 'pt' ? ptPT : esES}>
      <BrowserRouter basename={'/'}>
        <App />
      </ BrowserRouter>
    </ ConfigProvider>
  </ Provider>
);

reportWebVitals();
